// ============================================================================
// Import globals.js first to ensure all libraries are available as window
// globals before any component code executes
// ============================================================================
import './globals.js';

// ============================================================================
// Project scripts
// ============================================================================
// IMPORTANT: This script must be loaded with defer attribute or at end of body
// to ensure DOM is ready when component IIFEs execute

import './clickable-element.js';
import './engage-browser-location.js';

import '../components/02-atoms/button/button-primary/button-primary.js';
import '../components/02-atoms/forms/forms.js';
import '../components/02-atoms/range-slider/range-slider.js';
import '../components/02-atoms/forms/select/select--choices.js';

import '../components/03-molecules/alert-popup/alert-popup.js';
import '../components/03-molecules/countdown/countdown.js';
import '../components/03-molecules/counter/counter.js';
import '../components/03-molecules/faqs/faqs.js';
import '../components/03-molecules/footer-utils/footer-utils.js';
import '../components/03-molecules/header-mobile-nav/header-mobile-nav.js';
import '../components/03-molecules/header-desktop-nav/header-desktop-nav.js';
import '../components/03-molecules/header-search/header-search.js';
import '../components/03-molecules/selector/selector.js';
import '../components/03-molecules/image-slider/image-slider.js';
import '../components/03-molecules/intro-media/intro-media.js';
import '../components/03-molecules/inline-search/inline-search.js';
import '../components/03-molecules/language-select/language-select.js';
import '../components/03-molecules/marquee/marquee.js';
import '../components/03-molecules/radiobutton-group/radiobutton-group.js';
import '../components/03-molecules/search-toggle/search-toggle.js';
import '../components/03-molecules/slider/slider.js';
import '../components/03-molecules/slider-extended/slider-extended.js';
import '../components/03-molecules/step-slider/step-slider.js';
import '../components/03-molecules/submenu/submenu.js';
import '../components/03-molecules/header-utils/header-utils.js';
import '../components/03-molecules/social-feed/social-feed.js';
import '../components/03-molecules/showcase/showcase.js';
import '../components/03-molecules/contact-cta/contact-cta.js';
import '../components/03-molecules/vacancy-reminder/vacancy-reminder.js';
import '../components/03-molecules/video-player/video-player.js';
import '../components/03-molecules/section-slider/section-slider.js';

import '../components/04-organisms/hero/hero.js';
import '../components/04-organisms/numbers-block/numbers-block.js';
import '../components/04-organisms/article-block/article-block.js';
import '../components/04-organisms/search-header/search-header.js';
import '../components/04-organisms/logo-block/logo-block.js';
import '../components/04-organisms/header/header.js';
import '../components/04-organisms/navigation/navigation.js';
import '../components/04-organisms/content-header/content-header.js';
import '../components/04-organisms/social-feed-block/social-feed-block.js';
import '../components/04-organisms/video-block/video-block.js';
import '../components/04-organisms/showcase-block/showcase-block.js';
import '../components/04-organisms/highlight-block/highlight-block.js';
import '../components/04-organisms/grid-block/grid-block.js';
import '../components/04-organisms/case-block/case-block.js';
import '../components/04-organisms/compliments-grid/compliments-grid.js';
import '../components/04-organisms/salary-calculator-block/salary-calculator-block.js';
import '../components/04-organisms/holiday-salary-calculator-block/holiday-salary-calculator-block.js';
import '../components/04-organisms/choices-block/choices-block.js';
import '../components/04-organisms/travel-time-calculation-block/travel-time-calculation-block.js';
import '../components/04-organisms/vacancy-hero/vacancy-hero.js';
import '../components/04-organisms/vacancy-page-hero/vacancy-page-hero.js';

import '../components/04-organisms/vacancy-highlight-block/vacancy-highlight-block.js';
import '../components/05-templates/vacancy-overview/vacancy-overview.js';
import '../components/05-templates/adventskalender/adventskalender.js';
import '../components/05-templates/f19/f19.js';
import '../components/05-templates/jobalert-page/jobalert-page.js';

// ============================================================================
// Scroll indicator and header height CSS variables
// ============================================================================

const vebegoHeader = document.querySelector('.vebego-header');

if (vebegoHeader) {
    document.documentElement.style.setProperty(
        '--breadcrumbs-padding-top',
        vebegoHeader.offsetHeight + 'px'
    );
    document.documentElement.style.setProperty(
        '--content-padding-top',
        vebegoHeader.offsetHeight + 'px'
    );
}

window.onscroll = function () {
    scrollIndicator();
};

function scrollIndicator() {
    var winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
    var height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;

    if (document.getElementById('scrollIndicator') != null) {
        document.getElementById('scrollIndicator').style.width = scrolled + '%';
    }
}
